// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d88abbec","455":"5c8e3a7c","977":"5508799c"}[chunkId] + ".chunk.js";
};